module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-break-f1c555b2.svg";